// extracted by mini-css-extract-plugin
export default {"container":"MyMessages_container__01h6Z","messageContent":"MyMessages_messageContent__Iqn1A"};